// Preview only. The server freezes the actual job ranges at each occurrence.
const DAY = 86400000;
const SPLITS = new Set(['single', 'weekly', 'monthly', 'quarterly', 'yearly']);
const MONTHS = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];

export function buildExportPeriods(dateFrom, dateTo, splitBy = 'single') {
  if (!SPLITS.has(splitBy)) throw new RangeError('Select a supported job period.');
  if (!dateFrom || !dateTo) return [{ dateFrom, dateTo, label: '' }];
  const end = new Date(`${dateTo}T00:00:00Z`);
  let cursor = new Date(`${dateFrom}T00:00:00Z`);
  if (!Number.isFinite(cursor.getTime()) || !Number.isFinite(end.getTime())
      || cursor.toISOString().slice(0, 10) !== dateFrom || end.toISOString().slice(0, 10) !== dateTo) {
    throw new RangeError('Select valid start and end dates.');
  }
  if (cursor > end) throw new RangeError('The end date must follow the start date.');
  if (splitBy === 'single') return [{ dateFrom, dateTo, label: '' }];
  const periods = [];
  while (cursor <= end) {
    const year = cursor.getUTCFullYear();
    const month = cursor.getUTCMonth();
    let boundary;
    let label;
    if (splitBy === 'weekly') {
      const weekday = (cursor.getUTCDay() + 6) % 7;
      boundary = new Date(cursor.getTime() + (7 - weekday) * DAY);
      const thursday = new Date(cursor.getTime() + (3 - weekday) * DAY);
      const isoYear = thursday.getUTCFullYear();
      const yearStart = new Date(0);
      yearStart.setUTCFullYear(isoYear, 0, 1);
      const week = Math.ceil(((thursday - yearStart) / DAY + 1) / 7);
      label = `Week ${String(week).padStart(2, '0')} ${isoYear}`;
    } else {
      const nextMonth = splitBy === 'monthly' ? month + 1 : splitBy === 'quarterly' ? (Math.floor(month / 3) + 1) * 3 : 12;
      boundary = new Date(0);
      boundary.setUTCFullYear(year, nextMonth, 1);
      label = splitBy === 'monthly' ? `${MONTHS[month]} ${year}` : splitBy === 'quarterly' ? `Q${Math.floor(month / 3) + 1} ${year}` : String(year);
    }
    periods.push({ dateFrom: cursor.toISOString().slice(0, 10), dateTo: new Date(Math.min(end.getTime(), boundary.getTime() - DAY)).toISOString().slice(0, 10), label });
    if (periods.length > 1000) throw new RangeError('This range exceeds 1000 period jobs. Choose a smaller range or larger job periods.');
    cursor = boundary;
  }
  return periods;
}

export function createExportDefinition(draft, destination) {
  // Strip the old "one saved export per period" metadata even when editing a draft.
  const { exportGroupId, partitionIndex, partitionCount, label, ...definition } = draft;
  return { ...definition, name: draft.name.trim(), baseName: draft.name.trim(), destination };
}
